import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserSettingsRoutes } from '@settings/settings.routes';
import { PageTitleComponent } from '@shared/components/sections/page-title/page-title.component';
import { StepNavigatorComponent } from '@shared/components/ui/step-navigator/step-navigator.component';
import { IStepNavigatorConfig, StepDisplay, StepModes, StepUI } from '@shared/models/step-navigator';

@Component({
	selector: 'app-settings-user',
	imports: [CommonModule, PageTitleComponent, RouterOutlet, StepNavigatorComponent],
	templateUrl: './settings-user.component.html',
	styleUrl: './settings-user.component.scss',
})
export class SettingsUserComponent {
	stepConfig: IStepNavigatorConfig = {
		ui: StepUI.WIZARD,
		mode: StepModes.ROUTER_OUTLET,
		displayType: StepDisplay.AUTO,
		showStepChevrons: false,
		showStepNumbers: false,
		showNavButtons: true,
		steps: [
			{
				icon: 'bi-person-circle',
				title: {
					full: 'Profile',
					tabs: 'Profile',
				},
				route: [UserSettingsRoutes.PROFILE],
			},
			{
				icon: 'bi-bell',
				title: {
					full: 'Notifications',
					tabs: 'Notifications',
				},
				route: [UserSettingsRoutes.NOTIFICATIONS],
			},
			{
				icon: 'bi-mailbox-flag',
				title: {
					full: 'Invitations',
					tabs: 'Invitations',
				},
				route: [UserSettingsRoutes.ORGANISATION_INVITES],
			},
		],
	};
}
